import React from "react";
import { BrowserRouter, useLocation } from "react-router-dom";
import Routers from "../../routers";
import TopHeader from "./TopHeader";
import Sidebar from "./Sidebar";
import Footer from "./Footer";
import AppContext from "./context";
import { useTopHeaderNotifications } from "./TopHeader/hooks";
import Notifications from "./TopHeader/TopHeaderNotifications";
import styled, { createGlobalStyle } from "styled-components";
import * as colors from "../../assets/_base/colors";
import StartupAwardsBanner from "../../components/StartupAwardsBanner";

import { getConfig } from "../../utils/config";

const config = getConfig();

const font = config.theme.font;

const GlobalStyle = createGlobalStyle`
  /* Importa as famílias do Google Fonts */
  @import url('${font.url}');
* {
  font-family: '${font.family}';
}
h1,
h2,
h3,
h4 {
  font-size: 1em !important;
}
`;

const Wrapper = styled.div`
  display: flex;
  min-height: 100vh;
  background-color: ${colors.lightCyan};
`;

const ContentArea = styled.div`
  flex: 1;
  margin-left: 240px;
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  box-sizing: border-box;
  min-width: 0;

  @media (max-width: 768px) {
    margin-left: 0;
  }
`;

const PageWrapper = styled.main`
  flex: 1;
  margin-left: 0;
  padding: 2rem;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  gap: 1rem;
  background-color: #f8f9fa;
  border-radius: 23px;
  box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.08);
  margin-top: 1rem;
  margin-right: 1rem;
  margin-bottom: ${props => props.hideFooter ? '1rem' : '5.4rem'};
  overflow-x: hidden;
  transition: all 0.3s ease-in-out;

  @media (max-width: 768px) {
    margin-right: 0;
    padding: 1rem;
    border-radius: 0;
  }
`;

const StyledFooter = styled.footer`
  position: fixed;
  bottom: 0;
  left: 240px;
  right: 0;
  height: ${props => props.hideBar ? '0' : '50px'};
  background: ${props => props.hideBar ? 'transparent' : '#ffffff'};
  color: #495057;
  font-size: 14px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-top: ${props => props.hideBar ? 'none' : '1px solid #dee2e6'};
  z-index: 900;
  pointer-events: ${props => props.hideBar ? 'none' : 'auto'};

  @media (max-width: 768px) {
    left: 0;
  }
`;

function AppLayout() {
  const location = useLocation();
  const isNfeIssuer = location.pathname === "/nfe/issuer";
  const ref = React.useRef(null);
  const getNotifications = useTopHeaderNotifications();
  const [currentBranch, setCurrentBranch] = React.useState({});
  const [notifications, setNotifications] = React.useState([]);

  React.useEffect(() => {
    let branchStr = window.localStorage.getItem("easygestorweb_current_branch");
    
    // Configurações do Shortcut 2073
    const path = location.pathname;
    const allowedPaths = ["/branches", "/branches/create", "/digital-certificate", "/plans/select", "/barcodes"];
    const isAllowed =
      allowedPaths.includes(path) ||
      path.startsWith("/branches") ||
      path.startsWith("/accountant") ||
      path.startsWith("/barcodes");

    if (!branchStr) {
      if (!isAllowed) {
        window.location.href = "/branches/create";
      }
      return;
    }

    if (branchStr) {
      const branch = JSON.parse(branchStr);
      
      if (!isAllowed) {
        if (!branch.certificate) {
          window.location.href = "/digital-certificate";
          return;
        }

        // Replica a mesma lógica que havia apenas no clique do menu lateral
        if (!branch.branch_plan) {
          window.location.href = "/plans/select";
          return;
        }
      }
      
      setCurrentBranch(branch);
      setNotifications(getNotifications(branch));
    }
  }, [ref.current, location.pathname]);

  return (
    <AppContext.Provider value={{ currentBranch }}>
      <Wrapper ref={ref}>
        <Sidebar />
        <ContentArea>
          <StartupAwardsBanner />
          <PageWrapper hideFooter={isNfeIssuer}>
            <TopHeader />
            <Notifications notifications={notifications} />
            <Routers />
          </PageWrapper>
        </ContentArea>
        <StyledFooter hideBar={isNfeIssuer}>
          <Footer />
        </StyledFooter>
      </Wrapper>
    </AppContext.Provider>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <GlobalStyle />
      <AppLayout />
    </BrowserRouter>
  );
}



// WEBPACK FOOTER //
// ./src/views/AppViews/index.jsx